import { message } from 'antd'
import api, { MetadataAttribute, MetadataEntity } from 'api'
import AppDialog from 'components/AppDialog'
import React from 'react'
import { AppForm } from 'components/AppFormLayout/AppForm'
import { EntityEditFieldFormData } from './EntityEditFieldFormData'

interface Props {
	mode: number
	afterSave?: (MetadataEntity: MetadataEntity) => void
	metadataAttribute: MetadataAttribute
	metadataEntity: MetadataEntity
}
// 字段信息编辑界面
export default class EntityEditFieldPage extends React.Component<Props> {
	// 确定
	saveFormData = async () => {
    if (typeof this.appFormRef.current === 'undefined') {
			return
		}
		let metadataEntity: MetadataEntity = await api.modeling.entity.getOne(this.props.metadataEntity)
		let metadataAttribute: MetadataAttribute =  (this.appFormRef.current as any).getFormData()
		if (!metadataAttribute) return
		metadataEntity.metadataAttributeList = metadataEntity.metadataAttributeList.filter(
			e => e.id !== metadataAttribute.id
		)
		metadataEntity.metadataAttributeList.push(metadataAttribute)
		let res = await api.modeling.entity.updateTable(metadataEntity)
		if (!res) {
			return
		}
		message.success('保存成功！')
		this.props.afterSave && this.props.afterSave(metadataEntity)
		AppDialog.close()
	}
	// 关闭
	close = () => {
		AppDialog.close()
  }
  FormActionData = [
		{ title: '保存', id: 'btnSave', type: 'primary', action: this.saveFormData },
		{ title: '取消', id: 'btnCancel', type: 'default', action: this.close },
	]
  appFormRef=React.createRef<unknown>();
	render() {
    let customerData = this.props.metadataAttribute
    console.log("customerData",customerData)
		return (
          <AppForm
          defaultTabId={0}
          appFormTabList={EntityEditFieldFormData}
          appFormActionList={this.FormActionData}
          mode={0}
          ref={this.appFormRef}
          customerData={customerData}
        />
		)
	}
}



// WEBPACK FOOTER //
// ./src/modules/modeling/entity/components/EntityEditFieldPage.tsx